import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { PermissionDeniedComponent } from "./permission-denied/permission-denied.component";

const routes: Routes = [
  {
    path: "permission-denied",
    component: PermissionDeniedComponent,
    data: {
      type: "permission-denied",
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SharedRoutingModule {}
